import React, { Component } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import './WhyMe.css'

class WhyMe extends Component {
  render() {
    if (!this.props.data) return null;

    const reasons = this.props.data.whyme.context.map(function (reason, index) {
      return (
        <Accordion 
          key={index}
          sx={{
            background: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(0, 255, 255, 0.3)',
            borderRadius: '10px !important',
            margin: '16px 0',
            boxShadow: '0 4px 20px rgba(0, 255, 255, 0.1)',
            '&:hover': {
              border: '1px solid rgba(255, 0, 255, 0.5)',
              boxShadow: '0 6px 25px rgba(255, 0, 255, 0.2)',
              transform: 'translateY(-2px)'
            },
            '&:before': {
              display: 'none'
            },
            transition: 'all 0.3s ease'
          }}
        >
          <AccordionSummary 
            expandIcon={
              <ExpandMoreIcon sx={{ 
                color: '#00ffff', 
                filter: 'drop-shadow(0 0 5px rgba(0, 255, 255, 0.8))',
                transition: 'all 0.3s ease',
                '&:hover': {
                  color: '#ff00ff',
                  filter: 'drop-shadow(0 0 8px rgba(255, 0, 255, 0.8))'
                }
              }} />
            }
            sx={{
              '& .MuiAccordionSummary-content': {
                margin: '16px 0'
              }
            }}
          >
            <Typography 
              variant="h6" 
              sx={{
                fontFamily: "'Orbitron', monospace",
                fontWeight: 600,
                color: '#00ffff',
                textShadow: '0 0 10px rgba(0, 255, 255, 0.6)',
                textTransform: 'uppercase',
                letterSpacing: 1
              }}
            >
              {reason.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: '16px 24px 24px 24px' }}>
            <Typography sx={{
              fontFamily: "'Rajdhani', sans-serif",
              fontSize: '1.1rem',
              lineHeight: 1.7,
              color: '#e0e0e0'
            }}>
              {reason.content}
            </Typography>
          </AccordionDetails>
        </Accordion>
      )
    });
    
    return (
      <div className="WhyMe">
        <Box sx={{ marginBottom: 6 }}>
          <Typography 
            variant="h2" 
            sx={{
              fontFamily: "'Orbitron', monospace",
              fontSize: '2.5rem',
              fontWeight: 700,
              background: 'linear-gradient(45deg, #00ffff, #ffbf00, #00ff7f)',
              backgroundSize: '200% 200%',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textTransform: 'uppercase',
              letterSpacing: 3,
              marginBottom: 2,
              animation: 'gradientShift 3s ease-in-out infinite'
            }}
          >
            How does it like working with me?
          </Typography>
          <Typography 
            variant="h5" 
            sx={{
              fontFamily: "'Rajdhani', sans-serif",
              fontSize: '1.3rem',
              color: '#e0e0e0',
              fontWeight: 400,
              textShadow: '0 0 5px rgba(255, 255, 255, 0.3)'
            }}
          >
            My team doctrine is simple: Truthful, Kind, and Enduring.
          </Typography>
        </Box>
        
        <div className="nine columns main-col" style={{
          maxWidth: '900px',
          margin: '0 auto',
          position: 'relative',
          zIndex: 1
        }}>
          {reasons}
        </div>
      </div>
    );
  }
}

export default WhyMe;